import Cookies from 'js-cookie'

export default {
    methods: {
        'logEvent': function(category, label, action) {
            if (typeof gtag == 'function') {
                gtag('event', action, {
                    'event_category': category,
                    'event_label': label,
                });
            }
        },
        translateForm: function(abbr) {
            switch (abbr) {
                case 'SOLN':
                    return "Solution";
                    break;
                case 'CRYS':
                    return "Crystals";
                    break;
                case 'CHEW':
                    return "Chewable Tablets";
                    break;
                case 'SOSY':
                    return "SOSY";
                    break;
                case 'SUSP':
                    return "Suspended Solution";
                    break;
                case 'SUPP':
                    return "Suppository";
                    break;
                case 'POWD':
                    return "Powder";
                    break;
                case 'ELIX':
                    return "Elixir";
                    break;
                case 'LIQD':
                    return "Liquid";
                    break;
                case 'GRAN':
                    return "Granules";
                    break;
                case 'TBCR':
                    return "Tablet Extended Release";
                    break;
                case 'CAPS':
                    return "Capsules";
                    break;
                case 'TABS':
                    return "Tablets";
                    break;
                case 'SUSR':
                    return "Suspension Reconstitued";
                    break;
                default:
                    return abbr;
                    break;
            }
        },
        hasAccessCode: function() {
            var access_code = Cookies.get("QuilityRxGroupCode");
            return (typeof access_code != 'undefined') && access_code != null && access_code != '' && access_code != 'undefined'
        }
    }
}